// extracted by mini-css-extract-plugin
export default {"headerContainer":"ErrorModal_headerContainer__EAK5L","message":"ErrorModal_message__LQ8YJ","errorButton":"ErrorModal_errorButton__KPv2+"};